.tabs {
  display: flex;
  gap: var(--space-1);
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--color-divider);
  overflow-x: auto;
}

.tab {
  flex: none;
  min-height: 2.25rem;
  padding: 0 var(--space-3);
  border: none;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text-muted);
  font: inherit;
  cursor: pointer;
}

.tabOn {
  background: var(--color-surface-hover);
  color: var(--color-text);
  font-weight: 600;
}

.person {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  min-height: 2.5rem;
  flex-wrap: wrap;
}

.personText {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.sub {
  color: var(--color-text-muted);
  font-size: var(--font-size-xs);
}
